import { Checkbox, FormControlLabel, FormGroup, Paper } from '@mui/material';
import { useTheme } from '../contexts/themeContext';

const styles = {
  checkboxField: {
    paddingX: 1.75,
    paddingY: 0.75,
    backgroundColor: 'transparent',
    border: 1,
  },
};

export interface CheckboxFieldProps {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function CheckboxField({ label, ...props }: CheckboxFieldProps) {
  const { checked } = props;
  const { darkModeEnabled } = useTheme();

  return (
    <Paper
      elevation={0}
      sx={[
        styles.checkboxField,
        { borderColor: darkModeEnabled ? '#45484D' : '#c8c9cc' },
        !checked && {
          color: darkModeEnabled ? '#ffffff99' : '#00000099',
        },
      ]}
    >
      <FormGroup>
        <FormControlLabel control={<Checkbox {...props} />} label={label} />
      </FormGroup>
    </Paper>
  );
}
